import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import Hamburger from '@/components/Hamburger/index.vue'
// import { SimpleUploaderModule } from '@/store/modules/simple-uploader'
// import { MessageBox } from 'element-ui'

// const url = process.env.VUE_APP_BASE_API

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const sidebar = computed(() => {
  return AppModule.sidebar
})

const username = computed(() => {
  return UserModule.name
})

function toggleSideBar() {
  AppModule.ToggleSideBar(false)
}

async function logout() {
  // 退出前先判断是否有文件正在上传（由于目前是通过打开url方式来进行退出，这里暂时不会触发）
  // const needSimpleUploaderAlert = SimpleUploaderModule.isFileUploading
  // if(needSimpleUploaderAlert) {
  //   MessageBox.confirm('上传任务进行中，关闭会导致任务中断，请确认')
  //     .then(() => {
  //       UserModule.LogOut()
  //     })
  //     .catch(() => {})
  // }
  UserModule.LogOut()
  // redirectToLogin()
}


return { __sfc: true,sidebar, username, toggleSideBar, logout, Breadcrumb, Hamburger }
}

})